import { render, staticRenderFns } from "./ChatFilesUploadModal.vue?vue&type=template&id=77415463&scoped=true&"
import script from "./ChatFilesUploadModal.vue?vue&type=script&lang=js&"
export * from "./ChatFilesUploadModal.vue?vue&type=script&lang=js&"
import style0 from "./ChatFilesUploadModal.vue?vue&type=style&index=0&id=77415463&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77415463",
  null
  
)

export default component.exports